import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { MaquinariaAlbaranModel } from 'src/app/models/ventas/tablas-maestras.model';


export class MaquinariaListModalFormDefinition {
  public readonly formFields: Form<MaquinariaAlbaranModel>;
  public readonly model: Partial<MaquinariaAlbaranModel>;

  constructor(type: FormType, model: Partial<MaquinariaAlbaranModel>, _context: unknown = {}) {
    this.model = model;
    this.formFields = {
      name: 'maquinaria-albaran-list-modal',
      header: 'Detalle del registro',
      type,
      sections: this.getSections(),
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private getSections(): FormSection<MaquinariaAlbaranModel>[] {
    return [
      {
        name: '',
        fields: [
          this.textField('nombre', 'Nombre', 1, true, 4),
          this.textField('ref_proveedor', 'Ref. Proveedor', 2, true, 4),
          this.textField('proveedor', 'Proveedor', 3, true, 4),
          this.textField('familia', 'Familia', 4, true, 4),
          this.textField('existencias', 'Existencias', 5, true, 4),
          this.textField('pvp', 'P.V.P', 6, true, 4),
          this.textField('pvp_iva_inc', 'P.V.P IVA INC', 7, true, 4),
        ],
        width: 12,
        isVisible: true,
        order: 1,
      },
    ];
  }

  private textField(name: string, label: string, order: number, isVisible = true, width = 4, inputType: InputType = InputType.TEXT): FormField<MaquinariaAlbaranModel> {
    return {
      name,
      vinculatedFields: undefined,
      label,
      input: {
        type: inputType,
        isEditable: true,
        ...(inputType === InputType.TEXTAREA ? { textAreaConfiguration: { hasVoiceTranscription: false, canTakePhoto: false, photoField: undefined } } : {}),
      },
      width,
      conditions: this.conditions({ isVisible }),
      order,
    };
  }


  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }

}
